import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { CandidateSourcingData } from '@recruitee/candidate-types';
import type { UnwrapArray } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import { EncodeHTMLPipe, SimpleFormatPipe } from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-profile-sourcing',
  templateUrl: './candidate-profile-sourcing.component.html',
  styleUrls: ['./candidate-profile-sourcing.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EncodeHTMLPipe, SimpleFormatPipe, TranslatePipe],
})
export class CandidateProfileSourcingComponent {
  @Input() public sourcing: CandidateSourcingData;

  public trackByJsonString<
    T extends
      | UnwrapArray<CandidateSourcingData['workHistory']>
      | UnwrapArray<CandidateSourcingData['educationHistory']>,
  >(index: number, entity: T): string {
    return JSON.stringify(entity, null);
  }
}
